import React from 'react';
//import {authRoles} from '../../auth';

export const EmailConfigConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['admin', 'rh', 'rh_not_signer'],
    routes  : [
        {
            path     : '/email-config',
            component: React.lazy(() => import('./EmailConfig'))
        }
    ]
};